export enum UploadStatus {
  none,
  preparing,
  uploading,
  complete,
  paused,
  queued,
  error,
}
